import React, { useEffect, useState } from "react";
import {
  transformResultsToCompProfileData,
  formatBoldText,
} from "../../../../../services/commonService";
import InsightTable from "../../InsightTable";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function ChannelMixAndUtilization({ gtmModel = [], compView }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        // { key: "channel_type", label: "Channel Type" },
        { key: "utilization_level", label: "Utilization Level" },
        { key: "performance_metrics", label: "Performance Metrics" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        // { key: "channel_type", label: "Channel Type" },
        { key: "utilization_level", label: "Utilization Level" },
        { key: "performance_metrics", label: "Performance Metrics" },
        { key: "strategic_role", label: "Strategic Role" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  // const dummyData = [
  //   {
  //     region: "North America",
  //     primary_channel: {
  //       value: "Direct",
  //       source: "https://placeholder.source.com",
  //       data_type: "Derived",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from partner onboarding documentation.",
  //     },
  //     primary_channel_positive_insight: {
  //       value: "Direct",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from partner onboarding documentation.",
  //     },
  //     primary_channel_negative_insight: {
  //       value: "Direct",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from partner onboarding documentation.",
  //     },
  //     primary_channel_recent_development: {
  //       value: "Direct",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from partner onboarding documentation.",
  //     },
  //     sales_motion: {
  //       value: "Solution Selling",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.8,
  //       reasoning: "Based on vendor product classification.",
  //     },
  //     sales_motion_positive_insight: {
  //       value: "Solution Selling",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.85,
  //       reasoning: "Customer satisfaction surveys.",
  //     },
  //     sales_motion_negative_insight: {
  //       value: "Solution Selling",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.7,
  //       reasoning: "No ambulatory offerings available.",
  //     },
  //     sales_motion_recent_development: {
  //       value: "Solution Selling",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.8,
  //       reasoning: "Confirmed in feature update report.",
  //     },
  //     focus_area: {
  //       value: "High",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.9,
  //       reasoning: "Measured by deployment across all departments.",
  //     },
  //     focus_area_positive_insight: {
  //       value: "Fully integrated across EMR and billing.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.85,
  //       reasoning: "Feedback from implementation teams.",
  //     },
  //     focus_area_negative_insight: {
  //       value: "Integration delays in 2 sites.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.7,
  //       reasoning: "Deployment status reports.",
  //     },
  //     focus_area_recent_development: {
  //       value: "Resolved API issues in July.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.75,
  //       reasoning: "Engineering resolution ticket logged.",
  //     },
  //   },
  // ];

  useEffect(() => {
    const tempChannelMix = gtmModel.slice(0, 5).map((item) => ({
      channel_mix: item?.response?.channel_mix,
    }));
    const transformed = transformResultsToCompProfileData(tempChannelMix);
    setTabData(transformed);
    setTableBelowDescription(
      // formatBoldText(transformed?.[0]?.competitive_commentary)
      <ParsedTextWithLinks
        text={transformed?.[0]?.competitive_commentary || ""}
      />
    );
    // console.log("CHANNELMIX: " + JSON.stringify(transformed));
    // setTabData(dummyData);
  }, [gtmModel]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Channel Mix & Utilization"
      subtitle="Who moves their products and how they reach end customers."
      belowTableDescription={tableBelowDescription}
      data={tabData}
      metrics={columns}
      rowIdentifier="channel_type"
      actions={actions}
    />
  );
}

export default ChannelMixAndUtilization;
